import { create } from 'zustand';

export type RollMode = 'normal' | 'advantage' | 'disadvantage';

interface PendingRoll {
  notation: string;
  label: string;
}

interface DiceRollerState {
  isOpen: boolean;
  pendingRoll: PendingRoll | null;
  rollMode: RollMode;
  lastRollLabel: string | null;
  lastRollWasNat20: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  triggerRoll: (notation: string, label: string) => void;
  clearPendingRoll: () => void;
  setRollMode: (mode: RollMode) => void;
  setLastRollResult: (label: string, wasNat20: boolean) => void;
}

export const useDiceRollerStore = create<DiceRollerState>((set) => ({
  isOpen: false,
  pendingRoll: null,
  rollMode: 'normal',
  lastRollLabel: null,
  lastRollWasNat20: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  triggerRoll: (notation: string, label: string) =>
    set({ isOpen: true, pendingRoll: { notation, label } }),
  clearPendingRoll: () => set({ pendingRoll: null }),
  setRollMode: (mode: RollMode) => set({ rollMode: mode }),
  setLastRollResult: (label: string, wasNat20: boolean) =>
    set({ lastRollLabel: label, lastRollWasNat20: wasNat20 }),
}));
